module.exports = __webpack_public_path__ + "img/Phone.7ed86e97.png";